// Third Party Libraries Imports
import toast from "react-hot-toast";
import { AxiosResponse } from "axios";
import { useDispatch } from "react-redux";

// Local Imports
import { LOADING } from "../../store/actions";
import instance from "../../store/axios";
import KycReview from "../../models/kyc-review.model";

class WaitingApprovalService {
  private dispatch = useDispatch();

  public async getKycReviewListData(
    status: string[],
    page,
    searchWord,
    sortField,
    sortOrder
  ): Promise<KycReview[] | undefined> {
    this.dispatch({ type: LOADING, payload: true });
    let query: string = `?page=${page}&pageSize=20`;

    status.forEach((element: string, index: number) => {
      if (index === 0) {
        query += `&status[${index}]=${element}`;
      } else {
        query += `&status[${index}]=${element}`;
      }
    });

    if (searchWord) {
      query += `&search=${searchWord}`;
    }
    if (sortField) {
      query += `&sortField=${sortField || "createdAt"}`;
    }
    if (sortOrder) {
      query += `&sortOrder=${sortOrder === "ascend" ? "asc" : "desc"}`;
    }
    try {
      const response: AxiosResponse<{
        data: KycReview[];
        message: string;
      }> = await instance.get(`/${process.env.REACT_APP_ENDPOINT_VERSION}/kyc-review${query}`);
      return response.data.data;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem("star_prev_url", `/customers/waiting-approvals`);
      return undefined;
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }

  public async lockKycReviewRecord(kycReviewId: number): Promise<boolean> {
    this.dispatch({ type: LOADING, payload: true });

    try {
      await instance.post(`/${process.env.REACT_APP_ENDPOINT_VERSION}/kyc-review/${kycReviewId}/lock`);
      toast.success("Record locked successfully");
      return true;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem("star_prev_url", `/customers/waiting-approvals`);
      return false;
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }

  public async generateKycPdf(
    accountId: number,
    sendEmail,
    sync
  ): Promise<any> {
    this.dispatch({ type: LOADING, payload: true });
    let query: string = "";

    if (sendEmail) {
      query = `?email=${sendEmail}`;
    }

    if (sync) {
      if (query) {
        query += `&sync=${sync}`;
      } else {
        query = `?sync=${sync}`;
      }
    }

    try {
      const response = await instance.post(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/kyc-review/generate-and-upload-kyc-pdf/${accountId}${query}`
      );
      toast.success("KYC generated successfully");
      return response;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      return false;
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }

  public async releaseKycReviewRecord(kycReviewId: number): Promise<boolean> {
    this.dispatch({ type: LOADING, payload: true });

    try {
      await instance.post(`/${process.env.REACT_APP_ENDPOINT_VERSION}/kyc-review/${kycReviewId}/release`);
      toast.success("Record released successfully");
      return true;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem("star_prev_url", `/customers/waiting-approvals`);
      return false;
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }
}

export default WaitingApprovalService;
